import { IconProps } from '.';

const RightArrowIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={customClasses}
      viewBox="0 0 31 28"
      fill="none"
      {...rest}
    >
      <path
        d="M15.7828 2.16675L26.1489 12.5329L-6.39667e-07 12.5329L-5.30389e-07 15.0329L26.1489 15.0329L15.7828 25.399L17.5506 27.1667L30.0506 14.6667L30.9344 13.7829L30.0506 12.899L17.5506 0.39898L15.7828 2.16675Z"
        fill={color || 'var(--color-ui-stroke-primary'}
      />
    </svg>
  );
};

export default RightArrowIcon;
